export default __webpack_public_path__ + "static/media/self service breakfast.1953bf4d.svg";